/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class AutomationFinAiAgentAnalyzeIncidentsRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.issues');
  }
}
